// extracted by mini-css-extract-plugin
export var expandIcon = "fv_vv";
export var rotated = "fv_vw";